/*
 * @format
 *
 * Helpers for Demo Mode - a backend-free tour of the app driven by fake data.
 * Actions that would hit the backend (inviting users, saving details, opening
 * external links) surface an alert instead of failing silently.
 *
 * The alert is redux state (auth.demoUnavailableVisible) rendered by the
 * globally-mounted DemoUnavailableModal, so thunks and screens dispatch the
 * same action: dispatch(showDemoUnavailable()).
 */

import * as actionTypes from '../action-types';

export const DEMO_UNAVAILABLE_MESSAGE =
  'This feature is not available in demo mode.';

export const DEMO_UNAVAILABLE_TITLE = 'Demo mode';

export const showDemoUnavailable = () => ({
  type: actionTypes.DEMO_UNAVAILABLE_SHOWN,
});

export const dismissDemoUnavailable = () => ({
  type: actionTypes.DEMO_UNAVAILABLE_DISMISSED,
});
